/* global axios */
import ApiClient from './ApiClient';

class LandingPagesAPI extends ApiClient {
  constructor() {
    super('landing_page_sites', { accountScoped: true });
  }

  createSite(payload) {
    return axios.post(this.url, { landing_page_site: payload });
  }

  updateSite(siteId, payload) {
    return axios.patch(`${this.url}/${siteId}`, { landing_page_site: payload });
  }

  provisionSite(siteId) {
    return axios.post(`${this.url}/${siteId}/provision`);
  }

  getPage(siteId, pageId) {
    return axios.get(`${this.url}/${siteId}/landing_pages/${pageId}`);
  }

  createPage(siteId, payload) {
    return axios.post(`${this.url}/${siteId}/landing_pages`, {
      landing_page: payload,
    });
  }

  updatePage(siteId, pageId, payload) {
    return axios.patch(`${this.url}/${siteId}/landing_pages/${pageId}`, {
      landing_page: payload,
    });
  }

  deletePage(siteId, pageId) {
    return axios.delete(`${this.url}/${siteId}/landing_pages/${pageId}`);
  }

  publishPage(siteId, pageId) {
    return axios.post(`${this.url}/${siteId}/landing_pages/${pageId}/publish`);
  }

  unpublishPage(siteId, pageId) {
    return axios.post(
      `${this.url}/${siteId}/landing_pages/${pageId}/unpublish`
    );
  }

  pageInsights(siteId, pageId, period = 30) {
    return axios.get(`${this.url}/${siteId}/landing_pages/${pageId}/insights`, {
      params: { period },
    });
  }
}

export default new LandingPagesAPI();
